// The admin route: a password gate around the workspace.
//
// This file used to be 1255 lines holding the catalog, five dialogs, every API
// URL and a copy of each reset literal. All of that now lives under src/admin/;
// what is left is the thing this component is actually for.

import React, { useState } from 'react';
import { Alert, Box, Button, CssBaseline, Snackbar, TextField } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { AdminProvider, useAdmin } from '../admin/AdminStore';
import AdminWorkspace from '../admin/AdminWorkspace';
import AdminErrorBoundary from '../admin/AdminErrorBoundary';
import psTheme from '../ps/psTheme';
import '../ps/ps-tokens.css';
import '../admin/admin.css';

function AuthGate() {
  const { isAuthenticated, login, notification, dismissToast } = useAdmin();
  const [password, setPassword] = useState('');

  // Inside the gate, so a crash in the workspace leaves the session intact and
  // the boundary can render the theme it was given.
  if (isAuthenticated) {
    return (
      <AdminErrorBoundary>
        <AdminWorkspace />
      </AdminErrorBoundary>
    );
  }

  return (
    <div className="admin-root">
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '18px',
          p: 2,
        }}
      >
        <span className="admin-label" style={{ fontSize: 12, color: 'var(--ps-gold)' }}>
          THE_VIDEOS
        </span>
        <Box
          component="form"
          onSubmit={(e) => {
            e.preventDefault();
            login(password);
          }}
          sx={{ display: 'flex', gap: '4px', width: 320, maxWidth: '100%' }}
        >
          <TextField
            type="password"
            size="small"
            fullWidth
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            inputProps={{ 'aria-label': 'Password' }}
          />
          <Button type="submit" variant="contained">
            Enter
          </Button>
        </Box>
      </Box>

      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={dismissToast}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={dismissToast}
          severity={notification.severity}
          sx={{ minWidth: 280, boxShadow: '0 8px 28px rgba(0,0,0,0.55)' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </div>
  );
}

function Admin() {
  return (
    <ThemeProvider theme={psTheme}>
      <CssBaseline />
      <AdminProvider>
        <AuthGate />
      </AdminProvider>
    </ThemeProvider>
  );
}

export default Admin;
